import {DashboardTileId} from '../types/DashboardTileId';
import {DashboardTilePlacement} from '../types/DashboardTilePlacement';
import {allocateDashboardGrid} from './allocateDashboardGrid';
import {applyDashboardGridLayout} from './applyDashboardGridLayout';

export function reflowDashboardGrid(
  placements: DashboardTilePlacement[],
  visibleIds: DashboardTileId[]
): DashboardTilePlacement[] {
  const visibleIdSet = new Set(visibleIds);
  const visibleTiles = placements
    .filter((placement) => visibleIdSet.has(placement.id))
    .map((placement) => ({id: placement.id, size: placement.size}));

  const positioned = allocateDashboardGrid(visibleTiles);

  return positioned === null ? placements : applyDashboardGridLayout(placements, positioned);
}
